import React from 'react';
import VideoPlayerHLS from './VideoPlayerHLS';
import VideoPlayerMP4 from './VideoPlayerMP4';

const VideoPlayer = (props) => {
  const src = props.src.videoUrl ? props.src.videoUrl : '';
  const isMP4 = src.toLowerCase().endsWith('.mp4');
  const isHLS = src.toLowerCase().endsWith('.m3u8');
  return (
    <div>
    { isMP4 &&
      <VideoPlayerMP4 src={props.src} userId={props.userId} />
    }
    { isHLS &&
      <VideoPlayerHLS src={props.src} userId={props.userId} />
    }
    </div>
  );
}
export default VideoPlayer;
